interface IProps {
  content: any;
}

const Master = ({ content }: IProps) => {
  return content;
};

export default Master;
